import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@digipay/ngx-hybrid-service';
var AgentEnumsModel = /*#__PURE__*/function (AgentEnumsModel) {
  AgentEnumsModel[AgentEnumsModel["WEB"] = 0] = "WEB";
  AgentEnumsModel[AgentEnumsModel["Ios"] = 1] = "Ios";
  AgentEnumsModel[AgentEnumsModel["Android"] = 2] = "Android";
  return AgentEnumsModel;
}(AgentEnumsModel || {});
let NgxApiConfigService = /*#__PURE__*/(() => {
  class NgxApiConfigService {
    constructor(ngxHybridServiceService, environmentConfig) {
      this.ngxHybridServiceService = ngxHybridServiceService;
      this.environmentConfig = environmentConfig;
      this.agentMap = {
        [AgentEnumsModel.WEB]: this.environmentConfig.agents.web_agent,
        [AgentEnumsModel.Android]: this.environmentConfig.agents.android_agent,
        [AgentEnumsModel.Ios]: this.environmentConfig.agents.ios_agent
      };
      this.clientIdMap = {
        [AgentEnumsModel.WEB]: this.environmentConfig.client_id.web_clientId,
        [AgentEnumsModel.Android]: this.environmentConfig.client_id.android_clientId,
        [AgentEnumsModel.Ios]: this.environmentConfig.client_id.ios_clientId
      };
      this.clientSecretMap = {
        [AgentEnumsModel.WEB]: this.environmentConfig.client_secret.web_client_secret,
        [AgentEnumsModel.Android]: this.environmentConfig.client_secret.android_client_secret,
        [AgentEnumsModel.Ios]: this.environmentConfig.client_secret.ios_client_secret
      };
    }
    getApiConstants() {
      const platform = this.ngxHybridServiceService.detectPlatform();
      return {
        agent: this.agentMap[platform],
        clientId: this.clientIdMap[platform],
        clientSecret: this.clientSecretMap[platform],
        digipayVersion: this.environmentConfig.digipayVersion,
        clientVersion: this.environmentConfig.clientVersion
      };
    }
    getBasicAuthHeader() {
      const platform = this.ngxHybridServiceService.detectPlatform();
      return 'Basic ' + btoa(this.clientIdMap[platform] + ':' + this.clientSecretMap[platform]);
    }
    static {
      this.ɵfac = function NgxApiConfigService_Factory(t) {
        return new (t || NgxApiConfigService)(i0.ɵɵinject(i1.NgxHybridServiceService), i0.ɵɵinject('environmentConfig'));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxApiConfigService,
        factory: NgxApiConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxApiConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxApiConfigModule = /*#__PURE__*/(() => {
  class NgxApiConfigModule {
    static environmentConfig(environmentConfig) {
      return {
        ngModule: NgxApiConfigModule,
        providers: [{
          provide: 'environmentConfig',
          useValue: environmentConfig
        }]
      };
    }
    static {
      this.ɵfac = function NgxApiConfigModule_Factory(t) {
        return new (t || NgxApiConfigModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxApiConfigModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [NgxApiConfigService],
        imports: [CommonModule]
      });
    }
  }
  return NgxApiConfigModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-api-config
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxApiConfigModule, NgxApiConfigService };
